module.exports = __webpack_public_path__ + "static/media/header1.b9eaf769.gif";